import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const spacer = new BlockType({
  name: 'spacer',
  title: 'Spacer',
  compatibility: ['page'],
  component: () =>
    import(/* webpackChunkName: "SpacerBlock" */ './SpacerBlock.vue'),
  builder: () => BlockBuilder.create('spacer').property('ratio', 'regular'),
});
